@import "../../packages/shared/scss";

:host {
  display: block;
  visibility: visible;
  position: static;
  height: auto !important; // this is here to override the styles from app.scss
  z-index: $phn-z-index-header;

  .header {
    min-height: $phn-header-height-base;

    @include pds-media-query-min("xs") {
      min-height: $phn-header-height-xs;
    }

    @include pds-media-query-min("s") {
      min-height: $phn-header-height-s;
    }

    @include pds-media-query-min("m") {
      min-height: $phn-header-height-m;
    }

    @include pds-media-query-min("l") {
      min-height: $phn-header-height-l;
    }
  }

  .limited-width {
    @include pds-media-query-min("xxl") {
      max-width: p-px-to-rem(2560px);
      margin: 0 auto;
    }
  }
}
